import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { withDisplayName } from '@klarna/higher-order-components'

const styles = {
  alignItems: 'center',
  cursor: 'pointer',
  position: 'relative'
}

export function HeaderMenuButton ({ id, onClick, children, ...props }) {
  return (
    <div
      style={styles}
      {...props}
    >
      <div id={id} style={{ display: 'flex', alignItems: 'center' }} onClick={onClick}>
        {children}
      </div>
    </div>
  )
}

HeaderMenuButton.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default R.compose(
  withDisplayName('UserMenu')('User')
)(HeaderMenuButton)
